class MarqueeBar extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.marquee__track');
    this.group = this.querySelector('.marquee__group');
    if (!this.track || !this.group) return;

    this.speed = parseFloat(this.dataset.speed) || 60;
    this.observer = new ResizeObserver(() => this.layout());
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  // Clones the message group until the strip covers two screen widths —
  // otherwise wide monitors show a gap between repeats.
  layout() {
    const groupWidth = this.group.getBoundingClientRect().width;
    if (!groupWidth) return;

    const needed = Math.max(2, Math.ceil((this.offsetWidth * 2) / groupWidth));

    while (this.track.children.length < needed) {
      const clone = this.group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);
    }
    while (this.track.children.length > needed) {
      this.track.removeChild(this.track.lastElementChild);
    }

    this.track.style.setProperty('--marquee-copies', this.track.children.length);
    this.track.style.setProperty('--marquee-duration', `${groupWidth / this.speed}s`);
  }
}

customElements.define('marquee-bar', MarqueeBar);
